import React from "react";
import { useTranslation } from "react-i18next";
import { CancelOutlined } from "@mui/icons-material";
import { apiGetPolicyInfo, apiSubmitPolicyInfo, apiVehicleSearch } from "utils/API/TrxNowAPI";
import { useState, useRef, useEffect } from "react";
import "./VehicleInfo.scss";
import { stateOptions } from "./stateOptions";
import { PolicyLookupSpinner } from "../PolicyLookupSpinner";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { devLog } from "utils/devLog";
import { Popper } from "@mui/material";
import { buildSubmitPolicyData } from "./buildSubmitPolicyData";
import { VehicleTextField, VehicleSelectDropdown } from "./VehicleInfoFields";
//simple form which allows the user to confirm their current saved vehicle in the salesforce system
export default function VehicleInfo(props) {
  const { t } = useTranslation();
  const [year, setYear] = useState(props.vehicleInfoObj.year ? String(props.vehicleInfoObj.year) : "");
  const yearPlaceholder = t("ATF.PolicyInformation.ConfirmCustomerYear");
  const [selectedYear, setSelectedYear] = useState(
    props.vehicleInfoObj.year ? String(props.vehicleInfoObj.year) : yearPlaceholder,
  );
  const yearOptions = Array.from({ length: 101 }, (_, i) => String(new Date().getFullYear() - i));
  const [make, setMake] = useState(props.vehicleInfoObj.make);
  const [model, setModel] = useState(props.vehicleInfoObj.model);
  const [color, setColor] = useState(
    props.vehicleInfoObj.color?.toLowerCase() === "unknown" ? "" : props.vehicleInfoObj.color,
  );
  const [weight, setWeight] = useState(props.vehicleInfoObj.weight);
  const [licensePlateState, setLicensePlateState] = useState(props.vehicleInfoObj.licensePlateState);
  const [licensePlateNumber, setLicensePlateNumber] = useState(props.vehicleInfoObj.licensePlateNumber);
  const [last8VIN, setLast8VIN] = useState(props.vehicleInfoObj.last8VIN);
  const [vin, setVin] = useState(props.vehicleInfoObj.vin);

  const [disableYear, setDisableYear] = useState(!!props.disableYear);
  const [disableMake, setSisableMake] = useState(!!props.disableMake);
  const [disableModel, setDisableModel] = useState(!!props.disableModel);
  const [disableColor, setDisableColor] = useState(props.localGroup === "GST" ? false : !!props.disableColor);
  const [disableDrivetrainType, setDisableDrivetrainType] = useState(!!props.disableDrivetrainType);
  const [disableVin, setDisableVin] = useState(!!props.disableVin);

  const [vehicleSearchEnabled, setVehicleSearchEnabled] = useState(!!props.vehicleSearchEnabled);

  useEffect(() => {
    console.log("props.vehicleSearchEnabled", props.vehicleSearchEnabled);
    setVehicleSearchEnabled(!!props.vehicleSearchEnabled);
  }, [props.vehicleSearchEnabled]);

  const [drivetrainType, setDrivetrainType] = useState(["2WD", "4WD", "AWD"]);
  const [weightOptions, setWeightOptions] = useState([
    {
      label: "Light Duty: 0-10,000 lbs",
      fullName: "Light Duty",
      value: "lightDuty",
    },
    {
      label: "Medium Duty: 10,001-26,000 lbs",
      fullName: "Medium Duty",
      value: "mediumDuty",
    },
    {
      label: "Heavy Duty: 26,001+ lbs",
      fullName: "Heavy Duty",
      value: "heavyDuty",
    },
  ]);

  const [selectedDrivetrainType, setSelectedDrivetrainType] = useState(t("description.ConfirmVehicleDrivetrainType"));
  const [selectedWeight, setSelectedWeight] = useState(t("description.ConfirmVehicleWeight"));

  const [selectedLicensePlateState, setSelectedLicensePlateState] = useState(
    t("description.ConfirmVehicleLicensePlateState"),
  );
  const [selectedLicensePlateNumber, setSelectedLicensePlateNumber] = useState(
    t("description.ConfirmVehicleLicensePlateNumber"),
  );
  const [isSelectedDrivetrainType, setIsSelectedDrivetrainType] = useState(false);

  const [showDTError, setShowDTError] = useState(false);
  const [showDrivetrainType, setShowDrivetrainType] = useState(false);
  const [drivetrainTypeIndex, setDrivetrainTypeIndex] = useState(-1);
  const [weightIndex, setWeightIndex] = useState(-1);

  const [showWeightError, setShowWeightError] = useState(false);
  const [showLicensePlateStateError, setShowLicensePlateStateError] = useState(false);
  const [showLicensePlateNumberError, setShowLicensePlateNumberError] = useState(false);
  const [licensePlateStateIndex, setLicensePlateStateIndex] = useState(-1);
  const [contactId, setContactId] = useState("");

  const [submitStatus, setSutmitStatus] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [contact, setContact] = useState(null);

  const vehicleSearchTimeoutRef = useRef(null);
  const [vehicleSearchLoading, setVehicleSearchLoading] = useState(false);
  const DEBOUNCE_MS = 300;

  let contactInfo;
  useEffect(() => {
    if (props.currState.localGroup === "PBFL") {
      CallApiGetPolicyInfo();
    }
  }, []);

  const CallApiGetPolicyInfo = (e) => {
    setError("");
    devLog("CallApiGetPolicyInfo");
    setLoading(true);
    devLog("props.currState.MemberLookup", props.currState.MemberLookup);

    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: props.currState.MemberLookup.firstName,
        lastName: props.currState.MemberLookup.lastName,
        phoneNumber: props.currState.MemberLookup.phoneNumber,
        partnerCode: partnerCode,
        companyName: props.currState.MemberLookup.companyName,
        driverNumber: props.currState.MemberLookup.driverNumber,
        country: props.currState.MemberLookup.country,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      .then((json) => {
        devLog("apiGetPolicyInfo full response:", json);
        const data = json?.data;
        const contactInfoRaw =
          data?.memberInfo?.contactInfo ??
          json?.memberInfo?.contactInfo ??
          (data && (data.year != null || data.make != null || data.model != null) ? data : null);

        const hasError = data?.error ?? json?.error;
        const isContactInfo = typeof contactInfoRaw === "object" && contactInfoRaw !== null;

        if (isContactInfo && !hasError) {
          contactInfo = contactInfoRaw;
          setContact(contactInfo);
          const nextYear = contactInfo.year ?? "";
          const nextMake = contactInfo.make ?? "";
          const nextModel = contactInfo.model ?? "";
          const nextColor = contactInfo.color ?? "";
          const nextWeight = contactInfo.weight ?? "";
          const nextLicensePlateState = contactInfo.licensePlateState ?? "";
          const nextLicensePlateNumber = contactInfo.licensePlateNumber ?? "";
          const contactId = contactInfo.contactRef ?? "";

          setContactId(contactId);
          setLicensePlateState(nextLicensePlateState);
          setLicensePlateNumber(nextLicensePlateNumber);

          const stateOption = stateOptions.find((option) => option.value === nextLicensePlateState);
          if (stateOption) {
            setSelectedLicensePlateState(stateOption.label);
          }
          setYear(nextYear ? String(nextYear) : "");
          setSelectedYear(nextYear ? String(nextYear) : yearPlaceholder);
          setMake(nextMake);
          setModel(nextModel);
          setColor(nextColor);
          setWeight(nextWeight);
          devLog("PBFL vehicle info set from apiGetPolicyInfo:", {
            year: nextYear,
            make: nextMake,
            model: nextModel,
            color: nextColor,
            weight: nextWeight,
          });
        } else {
          console.warn(
            "apiGetPolicyInfo: no vehicle/contactInfo found or error. data keys:",
            data ? Object.keys(data) : "no data",
            "contactInfoRaw:",
            contactInfoRaw,
            "hasError:",
            !!hasError,
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        devLog("Error", error);
        setError(error.message);
        setLoading(false);
      });
  };
  async function sendMemberInfo() {
    const newState = {
      apiCallPending: false,
      towReasonRestricted: false,
    };

    await props.context.setAsyncState({
      apiCallPending: true,
    });

    try {
      const result = buildSubmitPolicyData({
        localGroup: props.localGroup,
        partnerCode,
        currState: props.currState,
        contactId,
        vehicleFields: {
          year,
          make,
          model,
          color,
          weight,
          vin,
          licensePlateState,
          licensePlateNumber,
          drivetrainType,
        },
      });

      if (result?.data) {
        const res = await apiSubmitPolicyInfo({
          data: result.data,
          companyParams: props.currState.currentCompanyParams,
        });
        if (typeof result.applyResponse === "function") {
          result.applyResponse(res, newState);
        }
        if (typeof result.onSuccess === "function") {
          if (props.localGroup === "PBFL") {
            devLog("PBFL res", res);
          }
          result.onSuccess(res, props.context);
        }
      }
      await props.context.setAsyncState(newState);
    } catch (e) {
      console.error(e);
      await props.context.setAsyncState(newState);
    }
  }

  function onSubmit(e) {
    e.preventDefault();
    if (submitStatus) {
      return;
    }

    setSutmitStatus(true);
    setShowWeightError(false);
    setShowLicensePlateStateError(false);
    setShowLicensePlateNumberError(false);
    try {
      if (props.localGroup === "PBFL" && (!weight || !licensePlateState || !licensePlateNumber)) {
        if (props.localGroup === "PBFL" && !weight) {
          setShowWeightError(true);
          setSutmitStatus(false);
        }
        if (props.localGroup === "PBFL" && !licensePlateState) {
          setShowLicensePlateStateError(true);
          setSutmitStatus(false);
        }
        if (props.localGroup === "PBFL" && !licensePlateNumber) {
          setShowLicensePlateNumberError(true);
          setSutmitStatus(false);
        }
        return;
      }

      if (showDrivetrainType) {
        if (drivetrainTypeIndex === 0 || drivetrainTypeIndex === 1 || drivetrainTypeIndex === 2) {
          setShowDTError(false);
          setIsSelectedDrivetrainType(true);
        } else {
          devLog("Drivetrain type isn't selected");
          setShowDTError(true);
          setIsSelectedDrivetrainType(false);
          setSutmitStatus(false);
          return;
        }
      }
      const loadData = {
        Year: year,
        Make: make,
        Model: model,
        Color: color,
        VIN: vin,
        Weight: weight,
        DrivetrainType: selectedDrivetrainType,
        contactRef: contactInfo?.contactRef,
        // FirstName: props.currState.FirstName,
        // LastName: props.currState.LastName,
      };

      devLog("VehicleInfo", props, loadData);

      props.context.setState(
        {
          Year: year,
          Make: make,
          Model: model,
          Color: color,
          Weight: weight,
          VIN: vin,
          DrivetrainType: selectedDrivetrainType,
        },
        () => {
          sendMemberInfo().then(() => {
            if (typeof props.onUserNext === "function") {
              props.onUserNext(loadData);
            }
            setSutmitStatus(false);
          });
        },
      );
    } catch (e) {
      console.error(e);
      setSutmitStatus(false);
    }
  }

  const onUserCancel = () => {
    devLog("UI Cancel pressed");
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const [vehicleName, setVehicleName] = useState("");

  const onVehicleSearch = async (sQuery) => {
    // if (searchMake != null) setMake(searchMake);
    devLog("sQuery", sQuery);
    const containsAlpha = /[a-zA-Z]/.test(sQuery);
    devLog("containsAlpha", containsAlpha);
    if (!containsAlpha) {
      devLog("Only numbers, don't call API");
      return;
    }
    setVehicleSearchLoading(true);
    apiVehicleSearch({
      data: {
        query: sQuery,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      .then((json) => {
        devLog("apiVehicleSearch response:", json);
        if (!json?.data?.error) {
          props.context.setState({
            vehicleSearchResults: json.data.vehicles,
          });
        }
      })
      .catch(() => {})
      .finally(() => setVehicleSearchLoading(false));
  };

  useEffect(() => {
    return () => {
      if (vehicleSearchTimeoutRef.current) clearTimeout(vehicleSearchTimeoutRef.current);
    };
  }, []);
  const vehicleSearchResults = props.currState?.vehicleSearchResults;

  const onSearchInputChange = (e, value, reason) => {
    const upper = (value || "").toUpperCase();
    if (vehicleSearchTimeoutRef.current) {
      clearTimeout(vehicleSearchTimeoutRef.current);
      vehicleSearchTimeoutRef.current = null;
    }
    if (upper.length >= 2) {
      vehicleSearchTimeoutRef.current = setTimeout(() => {
        vehicleSearchTimeoutRef.current = null;
        onVehicleSearch(upper);
      }, DEBOUNCE_MS);
    }
  };

  const vehicleSearchResultsList = Array.isArray(vehicleSearchResults)
    ? vehicleSearchResults
        .map((vehicle) => {
          if (typeof vehicle !== "object" || !vehicle) return null;
          const year = vehicle.year ?? "";
          const make = vehicle.make ?? "";
          const model = vehicle.model ?? "";
          if (!make && !model) return null;
          const yearStr = year ? `${year} ` : "";
          const label = `${yearStr}${make} ${model}`.trim();
          return { label, year: String(year), make: String(make), model: String(model) };
        })
        .filter(Boolean)
        .sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { sensitivity: "base" }))
    : [];

  const onSelectSearchOpt = (e, newValue) => {
    devLog("onSelectSearchOpt", newValue);
    setVehicleName(newValue.label != null ? String(newValue.label) : "");
    if (newValue && typeof newValue === "object") {
      setMake(newValue.make != null ? String(newValue.make).toUpperCase() : "");
      setModel(newValue.model != null ? String(newValue.model) : "");
      setYear(newValue.year != null ? String(newValue.year) : "");
      setSelectedYear(newValue.year != null ? String(newValue.year) : yearPlaceholder);
    }
    if (typeof props.context?.setState === "function") {
      props.context.setState({ vehicleSearchResults: null });
    }
  };

  const textFieldStyles = {
    border: "1px solid #aaa",
    borderRadius: "25px",
    background: "none",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  };
  const CustomPopper = (props) => (
    <Popper
      {...props}
      style={{ border: "none", boxShadow: "none", width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
    />
  );

  return (
    <div className="formContainer">
      {!loading && (
        <>
          <form onSubmit={onSubmit} className="form">
            {/*New Vehicle Make Search - MUI Autocomplete */}

            {vehicleSearchEnabled && props.allowVehicleInfoEdits !== false && (
              <>
                <div className="group-1 group-vehicle-info vehicle-search-row">
                  <Autocomplete
                    id="new-make-search"
                    className="vehicle-autocomplete"
                    componentsProps={{
                      paper: { className: "vehicle-autocomplete-dropdown" },
                    }}
                    PopperComponent={CustomPopper}
                    freeSolo
                    disableClearable
                    loading={vehicleSearchLoading}
                    options={vehicleSearchResultsList}
                    value={vehicleName || ""}
                    onInputChange={onSearchInputChange}
                    onChange={onSelectSearchOpt}
                    disablePortal
                    getOptionLabel={(option) =>
                      option == null ? "" : typeof option === "object" ? (option.label ?? "") : String(option)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option && typeof option === "object" && option.make != null
                        ? String(option.make).toUpperCase() === String(value || "").toUpperCase()
                        : String(option?.label ?? option ?? "") === String(value ?? "")
                    }
                    renderInput={(params) => (
                      <div className="vehicle-search-input-container">
                        <div style={{ fontSize: "16px", marginLeft: "10px", marginBottom: "3px" }}>
                          Search For Your Vehicle:{" "}
                        </div>
                        <FormControl disablePortal={true} focused={false} fullWidth={true} sx={{ border: "none" }}>
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="ex: 2024 Ford F150"
                            disableUnderline={true}
                            focused={false}
                            required={false}
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              endAdornment: (
                                <>
                                  {params.InputProps.endAdornment}
                                  <InputAdornment position="end" className="vehicle-search-icon-adornment">
                                    <SearchIcon className="vehicle-search-icon" />
                                  </InputAdornment>
                                </>
                              ),
                            }}
                            inputProps={{
                              ...params.inputProps,
                              disableUnderline: true,
                              autoComplete: "new-password",
                            }}
                            sx={textFieldStyles}
                          />
                        </FormControl>
                      </div>
                    )}
                  />
                </div>
              </>
            )}

            <VehicleSelectDropdown
              label={t("description.ConfirmVehicleYear")}
              id="year"
              toggleLabel={selectedYear}
              options={yearOptions}
              selectedValue={year}
              disabled={disableYear}
              placeholderClassName={!year ? "vehicle-year-placeholder" : ""}
              onSelect={(option) => {
                setSelectedYear(option);
                setYear(option);
              }}
            />

            <VehicleTextField
              label={t("description.ConfirmVehicleMake")}
              id="make"
              placeholder={t("ATF.PolicyInformation.ConfirmCustomerMake")}
              value={make}
              onChange={setMake}
              disabled={disableMake}
              uppercase
            />

            <VehicleTextField
              label={t("description.ConfirmVehicleModel")}
              id="model"
              placeholder={t("ATF.PolicyInformation.ConfirmCustomerModel")}
              value={model}
              onChange={setModel}
              disabled={disableModel}
              uppercase
            />

            <VehicleTextField
              label={t("description.ConfirmVehicleColor")}
              id="color"
              placeholder={t("ATF.PolicyInformation.ConfirmCustomerColor")}
              value={color}
              onChange={setColor}
              disabled={disableColor}
              uppercase
            />

            {props.localGroup === "PBFL" && (
              <>
                <VehicleTextField
                  label={t("description.ConfirmVehicleFullVIN")}
                  id="vin"
                  placeholder={t("description.FullVin")}
                  value={vin}
                  onChange={setVin}
                  disabled={disableVin}
                  uppercase
                />

                <VehicleSelectDropdown
                  label={t("description.ConfirmVehicleWeight")}
                  id="weight"
                  toggleLabel={selectedWeight}
                  options={weightOptions.map((option) => ({
                    ...option,
                    label: option.label,
                    value: option.value,
                    active: option.fullName === selectedWeight,
                  }))}
                  error={showWeightError && weightIndex === -1}
                  errorMessage={
                    showWeightError && selectedWeight === "Vehicle Weight"
                      ? t("description.VehicleWeightRequired")
                      : null
                  }
                  onSelect={(option, index) => {
                    setSelectedWeight(option.fullName);
                    setWeight(option.value);
                    setWeightIndex(index);
                  }}
                />

                <VehicleTextField
                  label={t("description.ConfirmVehicleLicensePlateNumber")}
                  id="licensePlateNumber"
                  placeholder={t("description.ConfirmVehicleLicensePlateNumber")}
                  value={licensePlateNumber}
                  onChange={setLicensePlateNumber}
                  uppercase
                />

                <VehicleSelectDropdown
                  label={t("description.ConfirmVehicleLicensePlateState")}
                  id="licensePlateState"
                  toggleLabel={selectedLicensePlateState}
                  options={stateOptions.map((option) => ({
                    ...option,
                    active: option.label === selectedLicensePlateState,
                  }))}
                  error={showLicensePlateStateError && licensePlateStateIndex === -1}
                  errorMessage={
                    showLicensePlateStateError &&
                    selectedLicensePlateState === t("description.ConfirmVehicleLicensePlateState")
                      ? t("description.LicensePlateStateRequired")
                      : null
                  }
                  onSelect={(option, index) => {
                    setSelectedLicensePlateState(option.label);
                    setLicensePlateStateIndex(index);
                    setLicensePlateState(option.value);
                  }}
                />
              </>
            )}

            {showDrivetrainType && (
              <VehicleSelectDropdown
                label={t("description.ConfirmVehicleDrivetrainType")}
                id="drivetrainType"
                toggleLabel={selectedDrivetrainType}
                options={drivetrainType.map((type) => ({
                  label: type,
                  value: type,
                  active: type === selectedDrivetrainType,
                }))}
                dropdownClassName="dropdown"
                toggleClassName=""
                itemClassName="dropdown-item"
                error={showDTError && drivetrainTypeIndex === -1}
                errorMessage={
                  showDTError && selectedDrivetrainType === "Drivetrain"
                    ? t("description.DerivetrainTypeError")
                    : null
                }
                onSelect={(option, index) => {
                  setSelectedDrivetrainType(option.value);
                  setDrivetrainTypeIndex(index);
                }}
              />
            )}

            <div className="footerContainer" style={{ display: "flex" }}>
              <div>
                <button
                  id="cancelButton"
                  type="button"
                  className="footer"
                  style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
                  onClick={onUserCancel}
                >
                  <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                  <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
                </button>
              </div>
              <div>
                <button type="submit" disabled={submitStatus} className="ui-btn">
                  {t("description.ConfirmVehicleSubmit")}
                </button>
              </div>
            </div>
          </form>
        </>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </div>
  );
}
